import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

import {MenuService} from "@services/menu/menu.service";
import {AuthService} from "@services/auth/auth.service";
import {UiHelperService} from "@services/ui-helper/ui-helper.service";
import {ApiService} from "@services/api.service";
import {HttpService} from "@services/http/http.service";
import {appRoutingEnum} from "@enums/appRoutingEnum";
import {SearchParamsService} from "@services/searchParams/search-params.service";
import {map} from "rxjs/operators";
import {combineLatest} from "rxjs";

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss'],
  standalone: false
})
export class FooterMenuComponent implements OnInit {
  @ViewChild('ionFooter', {static: false, read: ElementRef}) ionFooter!: ElementRef
  @ViewChild('activeIndicator', {static: true}) activePageIndicator!: ElementRef

  constructor(
    public menuService: MenuService,
    public auth: AuthService,
    public uiHelper: UiHelperService,
    private api: ApiService,
private http: HttpService,
    private searchParams: SearchParamsService,
  ) {
  }

  ngOnInit() {
    combineLatest([this.api.pageName$,
      this.searchParams.searchParams$.pipe(map(params => params.list != '' ? params.list : params.filter),)])
      .subscribe(([currentPage, currentSearch]) => {
        let hashMap:any = {
          favedMe: 'favorited_me',
          fav: 'favorited',
          distance: 'near-me',
          lastActivity: 'online'
        }
        let querySelector:any = 'li.' + currentPage;
        if (currentPage === appRoutingEnum.HOME) {
          querySelector = 'li.' + hashMap[currentSearch];
        }
        document.querySelectorAll('li').forEach(elem => elem.classList.remove('active'));
        let currentLi = document.querySelector(querySelector) as HTMLElement;
        currentLi?.classList.add('active');
      })
  }

}
